import { useCallback, useState } from 'react'
import { showAlert } from '../../utility/SweetAlert'
import ApiService from '../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const InteractorFundBalanceList = () => {
  const { t } = useTranslation()
  const [fundData, setFundData] = useState({})
  const { account } = useSelector((state) => state.account)

  const fundBalanceSearch = useCallback(
    (payload, setLoading = () => {}) => {
      let payloadRequest = { ...payload, keywords: { source: 'SELLER', account_uid: account.uid } }
      setLoading(true)
      ApiService.jsonRequest('/fund-balance/search', payloadRequest, (response) => {
        setLoading(false)
        if (response.status_code === 200) {
          setFundData(response.data?.items.length > 0 ? response.data?.items[0] : {})
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.uid, t],
  )

  return { fundData, fundBalanceSearch }
}

export default InteractorFundBalanceList
